let requestIns = null;
export const setConfigRequestIns = (adapter) => {
    requestIns = adapter;
};
export const getRequestIns = () => {
    if (!requestIns) {
        throw new Error('Need set adapter before using it');
    }
    return requestIns;
};
